import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Tooltip from "@mui/material/Tooltip";
import AlertIcon from "@mui/icons-material/Warning";
import IconButton from "@mui/material/IconButton";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ToastContainer, toast } from "react-toastify";
import {
  insertWppft,
  getWppftDetails,
  updateWppft,
  deleteWppftDetails,
  disableGpftDetails,
  dataFromLgd,
  get_entity_type,
  getDistrict,
  getBlockByDistrict,
  getVillageByBlock,
  disableWpftDetails
} from "../../api/User";
import "../Admin/table.css"
const WPPFT = ({ designationOptions, entityType, entityTYpeFacilitator }) => {
  const [errors, setErrors] = useState({});
  const userId = sessionStorage.getItem("user_id");
  const [blocks, setBlocks] = useState([]);
  const [villages, setVillages] = useState([]);
  const role_id = sessionStorage.getItem("role_id");
  const gpID = sessionStorage.getItem("gp_data") || "";
  const [formData, setFormData] = useState({
    user_id: userId,
    designation: "",
    mobile_no: "",
    full_name: "",
    email: "",
    entity_name: "",
    entity_type: "",
    district: "",
    block: "",
    gram_panchayat: "",
  });
  const [formErrors, setFormErrors] = useState({
    designation: "",
    mobile_no: "",
    full_name: "",
    email: "",
    entity_name: "",
    entity_type: "",
    district: "",
    block: "",
    gram_panchayat: "",
  });
  const [filteredData, setFilteredData] = useState([]);
  const [token, setToken] = useState(sessionStorage.getItem("token") || "");
  const [EntityTypeErr, setEntityTypeErr] = useState("");
  
  const [lgdCode, setLgdCode] = useState("");
  const [rows, setRows] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  const [editData, setEditData] = useState({
    user_id: userId,
    designation: "",
    mobile_no: "",
    full_name: "",
    email: "",
    entity_name: "",
    entity_type: "",
    district: "",
    block: "",
    gram_panchayat: "",
  });
  const [othersInput, setOthersInput] = useState(false);
  const [entityTypes, setEntityTypes] = useState([]);
  const [editOthersInput, setEditOthersInput] = useState(false);
  const [editOtherValue, setEditOtherValue] = useState("");
  const [entity, setEntity] = useState("");
  const [districts, setDistricts] = useState([]);
  const [entityName, setEntityName] = useState([]);
  const navigate = useNavigate();
  const [showOtherDesignation, setShowOtherDesignation] = useState(false);


  const fetchData = async () => {

    const data = {

      role_id: role_id,
      gp_data_id: "all",

    };
    try {
      const res = await getWppftDetails(token, data);
      console.log(res);
      if (res.status === "success") {
        setFilteredData(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", { autoClose: 1000 });
    }
  };

  useEffect(() => {
    handleReset();
    setOthersInput(false);
    fetchData();
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create an object to collect validation errors
    const errors = {};

    // Perform validation checks
    if (!formData.full_name) errors.full_name = 'Full Name is required';
    if (!formData.mobile_no) errors.mobile_no = 'Mobile No is required';
    if (!formData.email) errors.email = 'Email ID is required';
    if (!formData.entity_type) errors.entity_type = 'Entity Type is required';

    if (formData.mobile_no && !/^\d{10}$/.test(formData.mobile_no)) {
      errors.mobile_no = 'Mobile No must be 10 digits';
    }

    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Invalid Email ID format';
    }

    if (!formData.designation) errors.designation = 'Designation is required';

    if (formData.entity_type === 'District Panchayat' && !formData.district_name) {
      errors.district_name = 'District Name is required';
    }
    if ((formData.entity_type === 'Intermediate Panchayat' || formData.entity_type === 'Village Panchayat') && !formData.block_name) {
      errors.block_name = 'Block Name is required';
    }
    if (formData.entity_type === 'Village Panchayat' && !formData.gram_name) {
      errors.gram_name = 'Gram Panchayat Name is required';
    }

    if (formData.designation === 'Other' && !formData.other_designation) {
      errors.other_designation = 'Other Designation is required';
    }

    // Set errors in state
    setFormErrors(errors);

    // Stop form submission if there are validation errors
    if (Object.keys(errors).length > 0) return;

    // Proceed with API call if no validation errors
    try {
        await insertWppft(token, formData);  
        toast.success("Record Inserted Successfully", { autoClose: 1000 });
        fetchData();
        setFormData({
            full_name: '',
            mobile_no: '',
            email: '',
            entity_type: '',
            district_name: '',
            block_name: '',
            gram_name: '',
            designation: '',
            other_designation: '',
        });
    } catch (error) {
        console.error('Error submitting form:', error);
    }
};


  const validateMobileNo = (mobile_no) => {
    if (!mobile_no) return "Mobile Number is required.";

    if (!/^\d{10}$/.test(mobile_no)) return "Mobile Number must be exactly 10 digits.";

    if (mobile_no[0] === '0') return "Mobile Number cannot start with zero.";

    if (/^0{10}$/.test(mobile_no)) return "Mobile Number cannot be all zeros.";

    return "";
  };

  const validateFullName = (fullName) => {
    if (!fullName) {
      return "Full Name is required.";
    }
    const invalidCharRegex = /[^A-Z\s]/;
    if (invalidCharRegex.test(fullName)) {
      return "Full Name cannot contain numbers or special characters.";
    }
    return "";
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value, 
    }));

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() ? "" : prevErrors[name], 
    }));

    if (name === "mobile_no") {
      const numericValue = value.replace(/\D/g, '').slice(0, 10);
      setFormData((prevState) => ({
        ...prevState,
        [name]: numericValue,
      }));

      setFormErrors((prevState) => ({
        ...prevState,
        [name]: validateMobileNo(numericValue),
      }));
    } else if (name === "full_name") {
      const uppercaseValue = value.toUpperCase();
      const cleanedValue = uppercaseValue.replace(/[^A-Z\s]/g, '');

      setFormData((prevState) => ({
        ...prevState,
        [name]: cleanedValue,
      }));

      setFormErrors((prevState) => ({
        ...prevState,
        [name]: validateFullName(cleanedValue),
      }));
    } else if (name === "email") {
      const lowercaseValue = value.toLowerCase();
      setFormData((prevState) => ({
        ...prevState,
        [name]: lowercaseValue,
      }));

      setFormErrors((prevState) => ({
        ...prevState,
        [name]: validateEmail(lowercaseValue) ? "" : "Invalid email format",
      }));
    } else if (name === "designation") {
      if (value === "Other") {
        setOthersInput(true);
      } else {
        setOthersInput(false);
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
          other_designation: "",
        }));
      }
    } else if (name === "entity_type") {
      let updatedEntityName = '';
      if (value === "Village Panchayat") {
        updatedEntityName = entityName.village;
      } else if (value === "Block Panchayat") {
        updatedEntityName = entityName.block;
      } else if (value === "District Panchayat") {
        updatedEntityName = entityName.district;
      }

      setFormData((prevState) => ({
        ...prevState,
        entity_type: value,
        entity_name: updatedEntityName,
        district_name: value === "District Panchayat" ? "" : prevState.district_name,
        block_name: ["Intermediate Panchayat", "Village Panchayat"].includes(value) ? "" : prevState.block_name,
        gram_name: value === "Village Panchayat" ? "" : prevState.gram_name,
      }));

      setEntity(updatedEntityName);
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleEdit = (index) => {

    const selectedRecord = filteredData[index];
    const isOtherDesignation = !designationOptions.includes(selectedRecord.designation);

    setEditData({
      ...selectedRecord,
      designation: isOtherDesignation ? "Other" : selectedRecord.designation,
      customDesignation: isOtherDesignation ? selectedRecord.designation : "",
      entity_type: selectedRecord.entity_type,
    });
    fetchBlocks(selectedRecord.district_code);
    setVillages([]);
    fetchVillages(selectedRecord.district_code, selectedRecord.block_code);
   
    setOthersInput(isOtherDesignation);
    setOpenEditModal(true);
  };
  const handleEditChange = (event) => {
    const { name, value } = event.target;
    setEditData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "entity_type") {
      let updatedEntityName = '';
      if (value === "Village Panchayat") {
        updatedEntityName = entityName.village;
      } else if (value === "Block Panchayat") {
        updatedEntityName = entityName.block;
      } else if (value === "District Panchayat") {
        updatedEntityName = entityName.district;
      }
      setEditData((prevState) => {
        let updatedEntityType = value;
        let updatedEntityName = prevState.entity_type;

        if (name === "entity_type" && value == 3) {
          updatedEntityType = "Village Panchayat";
        }
        return {
          ...prevState,
          [name]: value,
          entity_type: updatedEntityType,
          entity_name: updatedEntityName,
          district: value === "District Panchayat" ? "" : prevState.district,
          block: ["Block Panchayat", "Village Panchayat"].includes(value) ? "" : prevState.block,
          gram_panchayat: value === "Village Panchayat" ? "" : prevState.gram_panchayat,
        };
      });
      setDistricts([]);
      setBlocks([]);
      setVillages([]);
      fetchDistricts();
    } else if (name === "district") {
      setEditData((prevState) => ({
        ...prevState,
        district: value,
        block: "",
        gram_panchayat: "",
      }));
      fetchBlocks(value);
      setBlocks([]);
      setVillages([]);
      fetchBlocks(value);
    } else if (name === "block_code") {
      const district_code = editData.district_code;
      setEditData((prevState) => ({
        ...prevState,
        block: value,
        gram_panchayat: "",
      }));
      setVillages([]);
      fetchVillages(district_code, value);
    } else if (name === "mobile_no") {
      const numericValue = value.replace(/\D/g, '').slice(0, 10);
      setEditData((prevState) => ({
        ...prevState,
        [name]: numericValue,
      }));
      setErrors((prevState) => ({
        ...prevState,
        [name]: validateMobileNo(numericValue),
      }));
    } else if (name === "full_name") {
      const uppercaseValue = value.toUpperCase();
      const cleanedValue = uppercaseValue.replace(/[^A-Z\s]/g, '');
      setEditData((prevState) => ({
        ...prevState,
        [name]: cleanedValue,
      }));
      setErrors((prevState) => ({
        ...prevState,
        [name]: cleanedValue.trim() ? "" : "Full Name is required.",
      }));
    } else if (name === 'designation') {
      const isOther = value === "Other";
      setEditData((prevState) => ({
        ...prevState,
        [name]: value,
        customDesignation: isOther ? prevState.customDesignation || "" : "",
      }));
      setOthersInput(isOther);
    } else if (name === 'otherDesignation') {
      setEditData((prevState) => ({
        ...prevState,
        customDesignation: value,
      }));
    }
    if (name === "entity_type") {

      setFormData({
        ...formData,
        entity_type: value,
        district: "",
        block: "",
        gram_panchayat: "",
      });
      setDistricts([]);
      setBlocks([]);
      setVillages([]);

      fetchDistricts();
    } else if (name === "district") {

      setFormData({
        ...formData,
        district: value,
        block: "",
        gram_panchayat: "",
      });
      setBlocks([]);
      setVillages([]);
      fetchBlocks(value);
    } else if (name === "block") {
      setFormData({
        ...formData,
        block: value,
        gram_panchayat: "",
      });
      setVillages([]);
      const district_code = formData.district;
      fetchVillages(district_code, value);
    } else {

      setFormData({
        ...formData,
        [name]: value,
      });
    }

    if (name === "block") {
      const district_code = formData.district;
      fetchVillages(district_code, value);
    }
    if (name === "district_code") {
      fetchBlocks(value);
    }
    else if (name === "district_code") {
      fetchDistricts(value);

      setEditData((prevState) => ({
        ...prevState,
        [name]: value,
      }));

    }
    else if (name === "block") {

      setEditData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }

    else if (name === "gram_panchayat") {

      setEditData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleEditSubmit = async (event) => {
    event.preventDefault();
    const errors = {
      full_name: editData.full_name.trim() ? "" : "Full Name is required.",
      mobile_no: validateMobileNo(editData.mobile_no),
      email: editData.email ? "" : "Email ID is required.",
      entity_type: editData.entity_type ? "" : "Entity Type is required.",
      designation: editData.designation ? "" : "Designation is required.",
      district: editData.designdistrictation ? "" : "District is required.",
      block: editData.block ? "" : "Block is required.",
      gram_panchayat: editData.gram_panchayat ? "" : "Gram Panchayat is required.",
    };
    setErrors(errors);
    const hasErrors = Object.values(errors).some((error) => error !== "");

    try {
      const dataToSubmit = {
        ...editData,
        designation: editData.customDesignation || editData.designation,
      };

      const res = await updateWppft(token, dataToSubmit);
      if (res.status === "success") {
        toast.success(res.message, { autoClose: 1000 });
        fetchData();
        handleReset();
        setOpenEditModal(false);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error updating record:", error);
      toast.error("An error occurred while updating the record.", { autoClose: 1000 });
    }
    setOthersInput(false);
  };
  const handleReset = () => {
    setFormData({
      user_id: userId,
      designation: "",
      mobile_no: "",
      full_name: "",
      email: "",
      entity_type: "",
      other_designation: "",
      district: "",
      block: "",
      gram_panchayat: "",

    });
    setFormErrors({
      designation: "",
      mobile_no: "",
      full_name: "",
      email: "",
      entity_type: "",
      district: "",
      block: "",
      gram_panchayat: "",

    });
    setEntity("")
    setOthersInput(false);
  };
  const handleDelete = (index) => {
    setDeleteIndex(index);
    setOpenDialog(true);
  };
  const handleConfirmDelete = async () => {
    if (deleteIndex !== null) {
      try {
        const idToDelete = filteredData[deleteIndex].id;
        await deleteWppftDetails(token, idToDelete);
        const updatedData = filteredData.filter((_, i) => i !== deleteIndex);
        setFilteredData(updatedData);
        toast.success("Deleted successfully", { autoClose: 1000 });
      } catch (error) {
        console.error("Error deleting item:", error);
        toast.error("An error occurred while deleting the item.", { autoClose: 1000 });
      }
    }
    setOpenDialog(false);
  };
  const handleCancelDelete = () => {
    setOpenDialog(false);
  };
  const handleToggleActive = (index) => {
    const updatedData = filteredData.map((row, i) =>
      i === index ? { ...row, active: !row.active } : row
    );
    setFilteredData(updatedData);
  };
  const handleDisableButton = async (is_active, ID) => {

    const newIsActive = is_active === 1 ? 0 : is_active;

    const data = {
      id: ID
    };

    try {
      const res = await disableWpftDetails(token, data);  
      if (res.status === "success") {
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === ID ? { ...row, is_active: newIsActive } : row
          )
        );
        toast.success("Updated successfully", { autoClose: 1000 });
        fetchData();
      } else {
        toast.error("An error occurred while updating the item.", { autoClose: 1000 });
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.", { autoClose: 1000 });
    }
  };
  const handleDesignationChange = (e) => {
    console.log(e.target.value);
    formData.designation = e.target.value
  };
  const handleEditDesignationChange = (e) => {
    const newValue = e.target.value;
    console.log(newValue);
    setEditData((prevState) => ({
      ...prevState,
      designation: newValue,
    }));
    setEditOtherValue(newValue);

  };

  useEffect(() => {
    const fetchEntityTypes = async () => {
      try {
        const res = await get_entity_type(token); 
        if (res.status === "success") {
          setEntityTypes(res.data); 
        } else {
          toast.error(res.message, { autoClose: 1000 });
        }
      } catch (error) {
        console.error("Error fetching entity types:", error);
        toast.error("An error occurred while fetching entity types.", { autoClose: 1000 });
      }
    };

    fetchEntityTypes();
  }, [token]);

  const fetchDistricts = async () => {
    try {
      const res = await getDistrict(token);
      if (res.status === "success") {
        setDistricts(res.data); 
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching districts:", error);
      toast.error("An error occurred while fetching districts.", { autoClose: 1000 });
    }
  };
  useEffect(() => {
    fetchDistricts();
  }, []);



  const fetchBlocks = async (district_code) => {
    try {
      const res = await getBlockByDistrict(token, district_code);
      if (res.status === "success") {
        setBlocks(res.data); 
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching blocks:", error);
      toast.error("An error occurred while fetching blocks.", { autoClose: 1000 });
    }
  };

  const fetchVillages = async (district_code, block_code) => {
    try {
      const res = await getVillageByBlock(token, district_code, block_code);
      if (res.status === "success") {
        setVillages(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching villages:", error);
      toast.error("An error occurred while fetching villages.", { autoClose: 1000 });
    }
  };

  return (
    <div className="container-fluid" style={{ height: "91vh" }}>
      <h2 style={{ top: "0", left: "0", margin: "16px" }}>
        Ward Panchyat Planning Formulation Team (WPPFT)
      </h2>
      <form className="row g-3 p-3" onSubmit={handleSubmit}>
        <div className="col-md-4">
          <label
            htmlFor="full_name"
            className="form-label"
            style={{ fontSize: "0.9rem", fontWeight: "800" }}
          >
            Full Name <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className={`form-control ${formErrors.full_name ? "is-invalid" : ""
              }`}
            name="full_name"
            id="full_name"
            value={formData.full_name}
            onChange={handleChange}
            placeholder="Enter the Full Name"
          />
          {formErrors.full_name && (
            <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
              {formErrors.full_name}
            </p>
          )}
        </div>
        <div className="col-md-4">
          <label
            htmlFor="mobile_no"
            className="form-label"
            style={{ fontSize: "0.9rem", fontWeight: "800" }}
          >
            Mobile No <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className={`form-control ${formErrors.mobile_no ? "is-invalid" : ""
              }`}
            name="mobile_no"
            id="mobile_no"
            value={formData.mobile_no}
            onChange={handleChange}
            placeholder="Enter the Mobile No"
          />
          {formErrors.mobile_no && (
            <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
              {formErrors.mobile_no}
            </p>
          )}
        </div>
        <div className="col-md-4">
          <label
            htmlFor="email"
            className="form-label"
            style={{ fontSize: "0.9rem", fontWeight: "800" }}
          >
            Email ID <span style={{ color: "red", fontWeight: "800" }}>*</span>
          </label>
          <input
            type="email"
            className={`form-control ${formErrors.email ? "is-invalid" : ""}`}
            name="email"
            id="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter the Email ID"
          />
          {formErrors.email && (
            <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
              {formErrors.email}
            </p>
          )}
        </div>
        <div className="col-md-4">
          <label htmlFor="entity_type" className="form-label" style={{ fontWeight: "800" }}>
            Entity Type <span style={{ color: "red" }}>*</span>
          </label>
          <select
            className={`form-select ${formErrors.entity_type ? "is-invalid" : ""}`}
            name="entity_type"
            id="entity_type1"
            value={formData.entity_type || ""}
            onChange={handleChange}
          >
            <option value="" disabled>
              Select Entity Type
            </option>
            {entityTypes.map((item, index) => (
              <option key={index} value={item.entity_code}>
                {item.entity_name}
              </option>
            ))}
          </select>
          {formErrors.entity_type && (
            <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
              {formErrors.entity_type}
            </p>
          )}
        </div>

        {(formData.entity_type == 1 ||
          formData.entity_type == 2 ||
          formData.entity_type == 3) && (
            <div className="col-md-4">
              <label htmlFor="district" className="form-label" style={{ fontWeight: "800" }}>
                District Name <span style={{ color: "red" }}>*</span>
              </label>
              <select
                className={`form-select ${formErrors.district ? "is-invalid" : ""}`}
                name="district"
                id="district"
                value={formData.district || ""}
                onChange={handleEditChange}
              >
                <option value="" disabled>
                  Select District Name
                </option>
                {districts?.map((district, index) => (
                  <option key={index} value={district.district_code}>
                    {district.district}
                  </option>
                ))}
              </select>
              {formErrors.district && (
                <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                  {formErrors.district}
                </p>
              )}
            </div>
          )}

        {(formData.entity_type == 2 || formData.entity_type == 3) && (
          <div className="col-md-4">
            <label htmlFor="block" className="form-label" style={{ fontWeight: "800" }}>
              Block Name <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className={`form-select ${formErrors.block ? "is-invalid" : ""}`}
              name="block"
              id="block"
              value={formData.block || ""}
              onChange={handleEditChange}
            >
              <option value="" disabled>
                Select Block Name
              </option>
              {blocks?.map((block, index) => (
                <option key={index} value={block.block_code}>
                  {block.block}
                </option>
              ))}
            </select>
            {formErrors.block && (
              <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                {formErrors.block}
              </p>
            )}
          </div>
        )}


        {formData.entity_type == 3 && (
          <div className="col-md-4">
            <label htmlFor="gram_panchayat" className="form-label" style={{ fontWeight: "800" }}>
              Gram Panchayat Name <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select"
              name="gram_panchayat"
              id="gram_panchayat"
              value={formData.gram_panchayat || ""}
              onChange={handleEditChange}
            >
              <option value="" disabled>
                Select Gram Panchayat Name
              </option>
              {villages?.map((village, index) => (
                <option key={index} value={village.gram_panchayat_code}>
                  {village.gram_panchayat}
                </option>
              ))}
            </select>
          </div>
        )}
        <div className="col-md-4">
          <label htmlFor="designation" className="form-label" style={{ fontWeight: "800" }}>
            Designation <span style={{ color: "red" }}>*</span>
          </label>
          <select
            className={`form-select ${formErrors.designation ? "is-invalid" : ""}`}
            name="designation"
            id="editDesignation"
            value={formData.designation}
            onChange={handleChange}
          >
            <option value="" disabled>Select Designation</option>
            {designationOptions?.map((item, index) => (
              <option key={index} value={item}>{item}</option>
            ))}
          </select>
          {formErrors.designation && (
            <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
              {formErrors.designation}
            </p>
          )}
        </div>
        {othersInput && (
          <div className="col-md-4">
            <label
              htmlFor="other_designation"
              className="form-label"
              style={{ fontSize: "0.9rem", fontWeight: "800" }}
            >
              Designation <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="other_designation"
              value={formData.other_designation || ""}
              placeholder="Enter Other Designation"
              onChange={(e) => setFormData((prevState) => ({
                ...prevState,
                [e.target.name]: e.target.value
              }))}
            />
          </div>
        )}

        <div className="d-flex justify-content-end">
          <div className="col-md-2 row mt-2">
            <Button
              variant="contained"
              onClick={handleReset}
              sx={{
                width: "70%",
                backgroundColor: "#323576",
                color: "#ffffff",
                "&:hover": {
                  backgroundColor: "#5E63C7",
                },
              }}
            >
              Reset
            </Button>
          </div>
          <div className="col-md-2 row mt-2">
            <Button
              variant="contained"
              type="submit"
              sx={{
                width: "70%",
                backgroundColor: "#323576",
                color: "#ffffff",
                "&:hover": {
                  backgroundColor: "#5E63C7",
                },
              }}
            >
              Submit
            </Button>
          </div>
        </div>
      </form>
     
      <Dialog
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          Edit Record
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setOpenEditModal(false)}
            aria-label="close"
            style={{ position: "absolute", right: 15, top: 7 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleEditSubmit}>
            <div className="row g-3">
              <div className="row g-3">
                <div className="col-md-4">
                  <label htmlFor="editFullName" className="form-label mt-3" style={{ fontWeight: "800" }}>
                    Full Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.full_name ? "is-invalid" : ""}`}
                    name="full_name"
                    id="editFullName"
                    value={editData?.full_name || ""}
                    onChange={handleEditChange}
                    placeholder="Enter the Full Name"
                    style={{ height: "56px" }}
                  />
                  {errors.full_name && (
                    <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                      {errors.full_name}
                    </p>
                  )}
                </div>
                <div className="col-md-4">
                  <label htmlFor="editMobileNo" className="form-label mt-3" style={{ fontWeight: "800" }}>
                    Mobile No <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.mobile_no ? "is-invalid" : ""}`}
                    name="mobile_no"
                    id="editMobileNo"
                    value={editData?.mobile_no || ""}
                    onChange={handleEditChange}
                    placeholder="Enter the Mobile No"
                    style={{ height: "56px" }}
                  />
                  {errors.mobile_no && (
                    <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                      {errors.mobile_no}
                    </p>
                  )}
                </div>
                <div className="col-md-4">
                  <label htmlFor="editEmail" className="form-label mt-3" style={{ fontWeight: "800" }}>
                    Email ID <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="email"
                    className={`form-control ${errors.email ? "is-invalid" : ""}`}
                    name="email"
                    id="editEmail"
                    value={editData?.email || ""}
                    onChange={handleEditChange}
                    placeholder="Enter the Email ID"
                    style={{ height: "56px" }}
                  />
                  {errors.email && (
                    <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                      {errors.email}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <label htmlFor="entity_code" className="form-label" style={{ fontWeight: "800" }}>
                  Entity Type <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className={`form-select ${formErrors.entity_code ? "is-invalid" : ""}`}
                  name="entity_code"
                  id="entity_code"
                  value={editData.entity_code || ""}
                  onChange={handleEditChange}
                  style={{ height: "56px" }}
                >
                  <option value="" disabled>
                    Select Entity Type
                  </option>
                  {entityTypes.map((item, index) => (
                    <option key={index} value={item.entity_code}> {item.entity_name}{item.localbody_type_code} </option>
                  ))}
                </select>
                {formErrors.entity_code && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {formErrors.entity_code}
                  </p>
                )}
              </div>

              {(editData.entity_code == 1 || editData.entity_code == 2 || editData.entity_code == 3) && (
                <div className="col-md-4">
                  <label htmlFor="district_code" className="form-label" style={{ fontWeight: "800" }}>
                    District Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className={`form-select ${formErrors.district_code ? "is-invalid" : ""}`}
                    name="district_code"
                    id="district_code"
                    value={editData.district_code || ""}
                    onChange={handleEditChange}
                    style={{ height: "56px" }}
                  >
                    <option value="" disabled>
                      Select District Name
                    </option>
                    {districts?.map((district, index) => (
                      <option key={index} value={district.district_code}>
                        {district.district}
                      </option>
                    ))}
                  </select>
                  {formErrors.district_code && (
                    <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                      {formErrors.district_code}
                    </p>
                  )}
                </div>
              )}

              {(editData.entity_code == 2 || editData.entity_code == 3) && (
                <div className="col-md-4">
                  <label htmlFor="block_code" className="form-label" style={{ fontWeight: "800" }}>
                    Block Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className={`form-select ${formErrors.block_code ? "is-invalid" : ""}`}
                    name="block_code"
                    id="block_code"
                    value={editData.block_code || ""}
                    onChange={handleEditChange}
                    style={{ height: "56px" }}
                  >
                    <option value="">
                      Select Block Name
                    </option>
                    {blocks?.map((block, index) => (
                      <option key={index} value={block.block_code}>
                        {block.block}
                      </option>
                    ))}
                  </select>
                  {formErrors.block_code && (
                    <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                      {formErrors.block_code}
                    </p>
                  )}
                </div>
              )}

              {editData.entity_code == 3 && (
                <div className="col-md-4">
                  <label htmlFor="gram_panchayat_code" className="form-label" style={{ fontWeight: "800" }}>
                    Gram Panchayat Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className="form-select"
                    name="gram_panchayat_code"
                    id="gram_panchayat_code"
                    value={editData.gram_panchayat_code || ""}
                    onChange={handleEditChange}
                    style={{ height: "56px" }}
                  >
                    <option value="">
                      Select Gram Panchayat Name
                    </option>
                    {villages?.map((village, index) => (
                      <option key={index} value={village.gram_panchayat_code}>
                        {village.gram_panchayat}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              <div className="col-md-4">
                <label htmlFor="designation" className="form-label" style={{ fontWeight: "800" }}>
                  Designation <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className={`form-select ${errors.designation ? "is-invalid" : ""}`}
                  name="designation"
                  id="editDesignation"
                  value={editData?.designation || ""}
                  onChange={handleEditChange}
                  style={{ height: "56px" }}
                >
                  <option value="" disabled>Select Designation</option>
                  {designationOptions.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}

                </select>
                {errors.designation && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {errors.designation}
                  </p>
                )}
              </div>

              {editData?.designation === "Other" && (
                <div className="col-md-4">
                  <label
                    htmlFor="otherDesignation"
                    className="form-label"
                    style={{ fontSize: "0.9rem", fontWeight: "800" }}
                  >
                    Other Designation <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.otherDesignation ? "is-invalid" : ""}`}
                    name="otherDesignation"
                    id="otherDesignation"
                    value={editData?.customDesignation || ""}
                    placeholder="Enter Other Designation"
                    onChange={handleEditChange}
                    style={{ height: "56px" }}
                    disabled={!othersInput} 
                  />
                  {errors.otherDesignation && (
                    <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                      {errors.otherDesignation}
                    </p>
                  )}
                </div>
              )}
              <div className="d-flex justify-content-end mt-3">
                <Button
                  variant="contained"
                  onClick={() => setOpenEditModal(false)}
                  style={{
                    marginRight: "10px",
                    backgroundColor: "#323576",
                    color: "#ffffff",
                    width: "12%",
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  style={{
                    backgroundColor: "#323576",
                    color: "#ffffff",
                    width: "12%",
                  }}
                >
                  Save
                </Button>
              </div>
            </div>
          </form>
        </DialogContent>
      </Dialog>
      <Dialog open={openDialog} onClose={handleCancelDelete}>
        <DialogTitle>
          <AlertIcon style={{ color: "red", marginRight: "8px" }} />
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          Are you sure you want to delete this record?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer />
    </div>
  );
};
export default WPPFT;